import { Outlet, ScrollRestoration } from "react-router-dom";
import { LazyMotion, MotionConfig, domAnimation } from "framer-motion";
import { Header } from "@/components/header";
import { Footer } from "@/components/footer";
import { PaymentTestModeBanner } from "@/components/payment-test-mode-banner";

import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";

export function RootLayout() {
  return (
    <LazyMotion features={domAnimation} strict>
      {/* reducedMotion="user" makes Framer Motion honour prefers-reduced-motion;
          the CSS media query alone cannot reach JS-driven inline styles. */}
      <MotionConfig reducedMotion="user">
        <div className="min-h-screen flex flex-col">
          <PaymentTestModeBanner />
          <Header />
          <main className="flex-grow">
            <Outlet />
          </main>
          <Footer />
        </div>
        <ScrollRestoration />
      </MotionConfig>
    </LazyMotion>
  );
}
